import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useMediaQuery } from '@mui/material';
import './filter.css';
import { FilterOption } from '../../interfaces';

const MenuProps = {
  PaperProps: {
    style: {
      minWidth: 200,
    },
  },
};

type Props = {
  name?: string;
  options: FilterOption[];
  state: string;
  setState: React.Dispatch<React.SetStateAction<string>>;
  // eslint-disable-next-line react/require-default-props
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  styleOverride?: React.CSSProperties;
  desktopWidth?: number;
};

export default function SingleSelectFilter({
  name,
  options,
  state,
  setState,
  setLoading,
  styleOverride,
  desktopWidth = 150,
}: Props) {
  const isDesktop = useMediaQuery('(min-width:900px)');

  // On select change, add the filtered option name to our state array
  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value === 'ALL' ? undefined : event.target.value;
    setState(value as string);
    if (setLoading) {
      setLoading(true);
    }

    if (!name) return;
    if (value) {
      sessionStorage.setItem(name, JSON.stringify(value));
    } else {
      sessionStorage.removeItem(name);
    }
  };

  return (
    <div>
      <FormControl
        sx={{ m: 1, width: isDesktop ? desktopWidth : '100%' }}
        style={styleOverride}>
        <Select
          value={state}
          input={<OutlinedInput />}
          slotProps={{
            input: {
              style: {
                paddingRight: '1em',
              },
            },
          }}
          autoWidth
          className="filter-select"
          MenuProps={MenuProps}
          IconComponent={ExpandMoreIcon}
          onChange={handleChange}>
          {options.map(option => (
            <MenuItem
              value={option.value}
              key={option.value}
              style={{ color: option.color }}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
